import React from 'react';

import {
  ConnectionSubmitButton, ConnectionEmailInput, ConnectionServiceDescription, ConnectionServicePrice,
  ConnectionFeeDescription, ConnectionServiceConnectedWarning, ConnectionServiceTitle, ConnectionTitle,
} from './connected';
import {
  PopupConnectionMainWrapper, PopupSectionInfo, PopupSectionTotal,
  PopupActionBar, ServiceSwitch,
} from '../../../../components';

export const Connection = () => (
  <PopupConnectionMainWrapper>
    <ConnectionTitle />

    <PopupSectionInfo>
      <ServiceSwitch isLoading disabled />
      <ConnectionServiceTitle />
      <ConnectionServiceDescription />
      <ConnectionServicePrice />
    </PopupSectionInfo>

    <PopupSectionTotal>
      <ConnectionFeeDescription />
      <ConnectionServiceConnectedWarning />
    </PopupSectionTotal>

    <PopupActionBar lonely>
      <ConnectionEmailInput />
      <ConnectionSubmitButton />
    </PopupActionBar>
  </PopupConnectionMainWrapper>
);
